export const QUALTRICS_APP_NAME =
  'ppmenodeweb-feedbacklink-sellerdashboard-jul2021'
